import { render, staticRenderFns } from "./CurationView.vue?vue&type=template&id=204d6bb8&scoped=true&"
import script from "./CurationView.vue?vue&type=script&lang=ts&"
export * from "./CurationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d6bb8",
  null
  
)

export default component.exports